import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    ICreateSampleRequestRequest,
    ISampleDecisionRequest,
    ISampleRequest,
    ISampleRequestPage,
    IUpdateSampleRequestRequest,
    IUpdateSampleStatusRequest,
    SampleStatus,
    SampleType,
} from '../interfaces/garments/sampleRequest.interface';

const headers = () => AuthService.getAuthHeader();

export const SampleRequestService = {
    list: async (
        institutionId: string,
        page = 0,
        size = 20,
        buyerId?: string,
        styleId?: string,
        status?: SampleStatus,
        sampleType?: SampleType,
        overdueOnly = false
    ): Promise<ISampleRequestPage> => {
        const res = await axios.get(ENDPOINTS.SAMPLE_REQUEST.LIST(institutionId), {
            headers: headers(),
            params: { page, size, buyerId, styleId, status, sampleType, overdueOnly },
        });
        return res.data;
    },

    getById: async (institutionId: string, id: string): Promise<ISampleRequest> => {
        const res = await axios.get(ENDPOINTS.SAMPLE_REQUEST.GET(institutionId, id), { headers: headers() });
        return res.data;
    },

    create: async (institutionId: string, request: ICreateSampleRequestRequest): Promise<ISampleRequest> => {
        const res = await axios.post(ENDPOINTS.SAMPLE_REQUEST.CREATE(institutionId), request, { headers: headers() });
        return res.data;
    },

    update: async (institutionId: string, id: string, request: IUpdateSampleRequestRequest): Promise<ISampleRequest> => {
        const res = await axios.put(ENDPOINTS.SAMPLE_REQUEST.UPDATE(institutionId, id), request, { headers: headers() });
        return res.data;
    },

    updateStatus: async (institutionId: string, id: string, request: IUpdateSampleStatusRequest): Promise<ISampleRequest> => {
        const res = await axios.patch(ENDPOINTS.SAMPLE_REQUEST.UPDATE_STATUS(institutionId, id), request, { headers: headers() });
        return res.data;
    },

    decision: async (institutionId: string, id: string, request: ISampleDecisionRequest): Promise<ISampleRequest> => {
        const res = await axios.patch(ENDPOINTS.SAMPLE_REQUEST.DECISION(institutionId, id), request, { headers: headers() });
        return res.data;
    },

    resubmit: async (institutionId: string, id: string): Promise<ISampleRequest> => {
        const res = await axios.post(ENDPOINTS.SAMPLE_REQUEST.RESUBMIT(institutionId, id), null, { headers: headers() });
        return res.data;
    },
};
